import { GET_USER_GROUP_URL } from '../../constants/apiUrls';
import { GET_USER_GROUP_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';

// =============================================================================
// Request & Response Model
// =============================================================================
export interface UserGroupResponse {
  id: number;
  displayName: string;
}

// =============================================================================
// Query
// =============================================================================
export const useGetUserGroup = () => {
  const getUserGroup = async () => {
    const res = await axiosClient.get<UserGroupResponse[]>(GET_USER_GROUP_URL);

    return res.data;
  };

  return useCustomQuery(GET_USER_GROUP_QUERY_KEY, getUserGroup, undefined, false);
};
